import {BrowserRouter as Router} from 'react-router-dom'
import MainRoute from './MainRoute';
import Public from './Public';
import AuthRoutes from './AuthRoute';
import Protected from './Protected';

const BrowserRoute = () => {
  return (
    <>
      <Public>
        <AuthRoutes />
      </Public>
      <Protected>
        <Router>
          <MainRoute />
        </Router>
      </Protected>
    </>
  );
};

export default BrowserRoute;
